import { defaultLang, regionLanguage } from '$lib/lang';
import { derived } from 'svelte/store';
import data from './data.json';

const strings: Record<string, Record<string, string>> = data;

export const messages = derived(regionLanguage, ($regionLanguage) => {
  return strings[$regionLanguage] || strings[defaultLang];
});
